const responseNotification = (
    status,
    notificationCallBack,
    authenticationCallBack,
    dispatch
) => {
    if (status == 400) {
        dispatch(
            notificationCallBack({
                status: "error",
                title: "ERROR",
                message: "A entrada foi mal formatada",
            })
        );
        dispatch(authenticationCallBack({ isAuthenticated: false }));
    } else if (status == 401) {
        dispatch(
            notificationCallBack({
                status: "error",
                title: "ERROR",
                message: "API não autorizou o acesso",
            })
        );
        dispatch(authenticationCallBack({ isAuthenticated: false }));
    } else if (status >= 500) {
        dispatch(
            notificationCallBack({
                status: "error",
                title: "ERROR",
                message: `Deu xabu dentro da API com status ${status}`,
            })
        );
    } else if (status != 200) {
        dispatch(
            notificationCallBack({
                status: "error",
                title: "ERROR",
                message: `A requisição teve erro com status ${status}`,
            })
        );
    }
};
export default responseNotification;
